const types = {
	//Get Template name
	GET_EQUIPMENT_EVALUATION_START: "GET_EQUIPMENT_EVALUATION_START",
	GET_EQUIPMENT_EVALUATION_SUCCESS: "GET_EQUIPMENT_EVALUATION_SUCCESS",
	GET_EQUIPMENT_EVALUATION_ERROR: "GET_EQUIPMENT_EVALUATION_ERROR",
	GET_EQUIPMENT_EVALUATION_RESET: "GET_EQUIPMENT_EVALUATION_RESET",

	//Create Template name
	CREATE_EQUIPMENT_EVALUATION_START: "CREATE_EQUIPMENT_EVALUATION_START",
	CREATE_EQUIPMENT_EVALUATION_SUCCESS: "CREATE_EQUIPMENT_EVALUATION_SUCCESS",
	CREATE_EQUIPMENT_EVALUATION_ERROR: "CREATE_EQUIPMENT_EVALUATION_ERROR",
	CREATE_EQUIPMENT_EVALUATION_RESET: "CREATE_EQUIPMENT_EVALUATION_RESET",

	//delete Template name
	DELETE_EQUIPMENT_EVALUATION_START: "DELETE_EQUIPMENT_EVALUATION_START",
	DELETE_EQUIPMENT_EVALUATION_SUCCESS: "DELETE_EQUIPMENT_EVALUATION_SUCCESS",
	DELETE_EQUIPMENT_EVALUATION_ERROR: "DELETE_EQUIPMENT_EVALUATION_ERROR",
	DELETE_EQUIPMENT_EVALUATION_RESET: "DELETE_EQUIPMENT_EVALUATION_RESET",

	//update Template name
	UPDATE_EQUIPMENT_EVALUATION_START: "UPDATE_EQUIPMENT_EVALUATION_START",
	UPDATE_EQUIPMENT_EVALUATION_SUCCESS: "UPDATE_EQUIPMENT_EVALUATION_SUCCESS",
	UPDATE_EQUIPMENT_EVALUATION_ERROR: "UPDATE_EQUIPMENT_EVALUATION_ERROR",
	UPDATE_EQUIPMENT_EVALUATION_RESET: "UPDATE_EQUIPMENT_EVALUATION_RESET",

	//single item  name
	SINGLE_EQUIPMENT_EVALUATION_START: "SINGLE_EQUIPMENT_EVALUATION_START",
	SINGLE_EQUIPMENT_EVALUATION_SUCCESS: "SINGLE_EQUIPMENT_EVALUATION_SUCCESS",
	SINGLE_EQUIPMENT_EVALUATION_ERROR: "SINGLE_EQUIPMENT_EVALUATION_ERROR",
	SINGLE_EQUIPMENT_EVALUATION_RESET: "SINGLE_EQUIPMENT_EVALUATION_RESET",
};

export default types;
